export default __webpack_public_path__ + "img/yape.3afca1fb.png";